import api from "@/router/api";
import apiPublic from "@/router/apiPublic";

export default {
  async getNoticiasHome(page = 0, size = 5, retornarNumPag) {
    const response = await apiPublic.get("/noticia/home", {
      params: { page, size },
    });

    if (retornarNumPag) {
      const numPag =
        response.data?.totalPages ?? response.data?.page?.totalPages ?? 1;
      const noticias =
        response.data?.content ??
        (Array.isArray(response.data) ? response.data : []);
      return { numPag, noticias };
    }
    return response.data?.content ?? response.data;
  },

  async buscarNoticiasPrex(
    titulo = "",
    page = 0,
    size = 10,
    retornarNumPag = false
  ) {
    const params = { page, size };
    if (titulo) params.titulo = titulo;
    const response = await apiPublic.get("/noticia/busca", { params });
    if (retornarNumPag) {
      const numPag =
        response.data?.totalPages ?? response.data?.page?.totalPages ?? 1;
      const noticias =
        response.data?.content ??
        (Array.isArray(response.data) ? response.data : []);
      return { numPag, noticias };
    }
    return response.data?.content ?? response.data;
  },

  async getAllNoticias(page, size, retornarNumPag) {
    const response = await api.get("/noticia", {
      params: { page, size },
      public: true,
    });

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        noticias: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data;
  },

  async getNoticiasAcao(page, size, acaoId, retornarNumPag) {
    const response = await api.get(`/noticia/acao/${acaoId}`, {
      params: { page, size },
    });

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        noticias: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data;
  },

  async getNoticiaById(id) {
    const response = await api.get(`/noticia/${id}`, { public: true });
    return response.data;
  },

  async postNoticiaAcao(dadosNoticia, acaoId) {
    const response = await api.post(`/noticia/acao/${acaoId}`, dadosNoticia);
    return response.data;
  },

  async filtrosNoticia({
    titulo = "",
    statusId = "",
    abrangenciaId = "",
    abrangencia = "",
    acaoId = "",
    dataInicial = "",
    dataFinal = "",
    page = 0,
    size = 10,
    unidadeId = null,
  }) {
    const params = { page, size };
    if (titulo) params.titulo = titulo;
    if (statusId) params.statusId = statusId;
    if (abrangenciaId) params.abrangenciaId = abrangenciaId;
    if (abrangencia) params.abrangencia = abrangencia;
    if (acaoId) params.acaoId = acaoId;
    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;
    if (unidadeId) params.unidadeId = unidadeId;

    const response = await api.get("/noticia/filtro", { params, public: true });
    return response;
  },

  async putNoticia(dadosNoticia, noticiaId) {
    const response = await api.put(`/noticia/${noticiaId}`, dadosNoticia);
    return response.data;
  },

  async excluirNoticia(noticiaId) {
    const response = await api.put(`/noticia/cancelar/${noticiaId}`);
    return response.data;
  },

  async getNoticiasByAbrangencia(page, size, abrangenciaId, retornarNumPag) {
    const response = await api.get(`/noticia/abrangencia/${abrangenciaId}`, {
      params: { page, size },
      public: true,
    });

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        noticias: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data;
  },

  async getNoticiasByUnidade(page, size, unidadeId, retornarNumPag) {
    const response = await api.get(`/noticia/unidade/${unidadeId}`, {
      params: { page, size },
      public: true,
    });

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        noticias: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data;
  },

  async getNoticiasByAbrangenciaAndStatus(
    page,
    size,
    abrangenciaId,
    isAutorizado,
    retornarNumPag
  ) {
    const response = await api.get(
      `/noticia/abrangencia/findByAbrangenciaAndStatus/${isAutorizado}`,
      {
        params: {
          page,
          size,
          abrangenciaId,
        },
      }
    );

    if (retornarNumPag) {
      return {
        numPag: response.data?.totalPages ?? 1,
        noticias: response.data?.content ?? response.data ?? [],
      };
    }
    return response.data?.content ?? response.data;
  },

  async autorizarNoticia(noticiaId, autorizado, motivoRejeicao = null) {
    const payload = {
      noticiaId,
      autorizado,
      motivoRejeicao: autorizado ? null : motivoRejeicao,
    };
    const response = await api.put("/noticia/aceitar", payload);
    return response.data;
  },

  async getAutorizarNoticia(
    page = 0,
    size = 10,
    status = [],
    titulo = "",
    filtros = {}
  ) {
    const params = { page, size };
    const statusLista = Array.isArray(status) ? status : [status];
    if (statusLista.length) {
      // "TODAS" é só valor de filtro da UI, não existe no enum do backend
      params.status = statusLista.filter((s) => s && s !== "TODAS");
    }
    if (titulo) {
      params.titulo = titulo;
    }
    [
      "unidadeId",
      "acaoId",
      "abrangencia",
      "escopo",
      "autorId",
      "autorizadorId",
      "dataInicial",
      "dataFinal",
      "sort",
    ].forEach((chave) => {
      if (filtros[chave]) params[chave] = filtros[chave];
    });
    const response = await api.get("/noticia/autorizar-noticia", {
      params,
      paramsSerializer: { indexes: null },
    });
    return response.data;
  },

  // Abrangências
  async getAllAbrangenciasNoticia() {
    const response = await apiPublic.get("/abrangencia-noticia");
    return response.data;
  },

  async getAbrangenciaNoticiaById(abrangenciaId) {
    const response = await apiPublic.get(`/abrangencia-noticia/${abrangenciaId}`);
    return response.data;
  },

  async getAbrangenciaNoticiaByName(abrangencia) {
    const response = await apiPublic.get("/abrangencia-noticia/busca", {
      params: { abrangenciaNoticia: abrangencia },
    });
    return response.data;
  },

  async postAbrangenciaNoticia(abrangenciaNoticia) {
    const response = await api.post("/abrangencia-noticia", abrangenciaNoticia);
    return response.data;
  },

  // Autores
  async getAllAutorNoticia() {
    const response = await api.get("/autor-noticia");
    return response.data;
  },

  async getAutorNoticiaById(autorNoticiaId) {
    const response = await api.get(`/autor-noticia/${autorNoticiaId}`);
    return response.data;
  },

  async getAutorNoticiaByName(autorNoticia) {
    const response = await api.get("/autor-noticia/busca", {
      params: { autorNoticia },
    });
    return response.data;
  },

  async postAutorNoticia(autorNoticia) {
    const response = await api.post("/autor-noticia", autorNoticia);
    return response.data;
  },

  // Status
  async getAllStatusNoticia() {
    const response = await api.get("/status-noticia");
    return response.data;
  },

  async getStatusNoticiaById(statusNoticiaId) {
    const response = await api.get(`/status-noticia/${statusNoticiaId}`);
    return response.data;
  },

  async getStatusNoticiaByName(statusNoticia) {
    const response = await api.get("/status-noticia/busca", {
      params: { statusNoticia },
    });
    return response.data;
  },

  async postStatusNoticia(statusNoticia) {
    const response = await api.post("/status-noticia", statusNoticia);
    return response.data;
  },

  // Destaques
  async getDestaques() {
    const response = await api.get("/noticia/destaques", { public: true });
    return response.data;
  },

  async postDestaque(dadosDestaque) {
    const response = await api.post("/noticia/destaques", dadosDestaque);
    return response.data;
  },

  async excluirDestaque(id) {
    const response = await api.delete(`/noticia/destaques/${id}`);
    return response.data;
  },

  async reordenarDestaques(dadosOrdenacao) {
    const response = await api.put(
      "/noticia/destaques/ordenacao",
      dadosOrdenacao
    );
    return response.data;
  },
};
